import React from 'react';
import type { TableFeatures } from './Table';

// Split contexts for better performance - components only re-render when their specific context changes
export const TableDimensionsContext = React.createContext<{
    totalColumns: number;
    totalRows: number;
    columnWidths: number[];
    features?: TableFeatures;
    onColumnResize: (columnIndex: number, newWidth: number) => void;
    onPreviewChange: (columnIndex: number | null, width: number | null) => void;
} | null>(null);

export const TableSelectionContext = React.createContext<{
    menuOpenForColumn: number | null;
    menuOpenForRow: number | null;
    setMenuOpenForColumn(index: number | null): void;
    setMenuOpenForRow(index: number | null): void;
    selectedRowIndex: number | null;
    setSelectedRowIndex(index: number | null): void;
    onRowSelectionChange: (rowIndex: number, isSelected: boolean) => void;
} | null>(null);

export const TableHoverContext = React.createContext<{
    hoveringResizeColumn: number | null;
    setHoveringResizeColumn: (column: number | null) => void;
} | null>(null);
